export const vantThemeVars = {
	themeVars: {
		"primary-color": "var(--main-color)",
		"tabs-card-height": "40px",
		"nav-bar-background": "var(--main-color)",
		"nav-bar-icon-color": "#000",
		"nav-bar-title-text-color": "#000",
		"tabbar-height": "82px",
		"border-color": "transparent",
		"tabbar-z-index": "999",
		"tabs-nav-background": "transparent",
		"tabbar-background": "#0B072C",
		"tabbar-item-active-background": "transparent",
		"tabbar-item-text-color": "#999",
		"tabbar-item-active-color": "var(--main-color)",
		"button-primary-color": "#0B072C",
		"button-plain-background": "transparent",
		"tab-text-color": "#000",
		"tab-active-text-color": "var(--main-color)",
		"count-down-text-color": "#F43D6B",
		"notice-bar-height": "40px",
		"circle-text-color": "#fff",
		"circle-text-font-size": "20px"
	},
	themeVarsDark: {},
	themeVarsLight: {}
};
